import { Spinner } from "@next-platform/client-common-spicy-ui";
import type { ReactNode } from "react";

import PageStaticMetaTags from "@/components/common/PageStaticMetaTags";
import AnonymousMarketing from "@/pages/AnonymousMarketing/AnonymousMarketing";
import { CREATION_TAB_META_PAGE_ID } from "@/pages/Creations/creationTabMetaPageId";
import useAuth from "@/services/useAuth";

import ChatbotMyLoggedIn from "./ChatbotMyLoggedIn";

export function ChatbotMy() {
  const { isAuthenticated, isLoading: isAuthLoading } = useAuth();

  let pageContent: ReactNode;
  if (isAuthLoading) {
    pageContent = <Spinner />;
  } else if (!isAuthenticated) {
    pageContent = <AnonymousMarketing datakey="creations" />;
  } else {
    pageContent = <ChatbotMyLoggedIn />;
  }

  return (
    <>
      <PageStaticMetaTags pageId={CREATION_TAB_META_PAGE_ID.chatbots} data-testid="ChatbotMy-PageStaticMetaTags" />
      {pageContent}
    </>
  );
}
export { default as CreationLayout } from "../Creations/CreationLayout";
